export default __webpack_public_path__ + "static/media/dialog-flow.805fa45f.svg";